export default __webpack_public_path__ + "static/media/cryptocurrency-trading.dc063ec0.jpg";